export default "__VITE_ASSET__DpInAHQQ__"